export class ChangePasswordModel {
  id: number
  currentPassword: string
  newPassword: string
  confirmPassword: string
}
